import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AccountService } from '@app/core/services';
import { User } from 'lingo2-models';
import { IUserCard } from '../meeting-user-card';

@Component({
  selector: 'app-invite-user-card',
  templateUrl: './invite-user-card.component.html',
  styleUrls: ['./invite-user-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InviteUserCardComponent implements OnInit {
  @Input() user: User;
  @Input() isInvited: boolean;
  @Output() invite = new EventEmitter<User>();

  constructor() {}

  ngOnInit(): void {}

  public get userCard(): IUserCard {
    const { id, userpic_id, country } = this.user || {};
    const fullName = AccountService.getUserFullName(this.user);
    return {
      id,
      userpic_id,
      title: fullName,
      description: country && country.title,
    };
  }

  public onInvite(): void {
    this.invite.emit(this.user);
  }
}
